import { render } from "./TmfDocQcList.vue?vue&type=template&id=1c60e65e&scoped=true"
import script from "./TmfDocQcList.js?vue&type=script&lang=js"
export * from "./TmfDocQcList.js?vue&type=script&lang=js"

import "./TmfDocQcList.vue?vue&type=style&index=0&id=1c60e65e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c60e65e"]])

export default __exports__